import {
    URLAPI,
    WORK_ACTIVITY_ADITIONAL_DATA_CREATE_PATH,
    WORK_ACTIVITY_ADITIONAL_DATA_DELETE_PATH
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _create_work_activity_aditional_data: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_work_activity_aditional_data: {
        data: {},
        status: 0,
        message: {},
    },
};

export const CREATE_WORK_ACTIVITY_ADITIONAL_DATA = "CREATE_WORK_ACTIVITY_ADITIONAL_DATA";
export const DELETE_WORK_ACTIVITY_ADITIONAL_DATA = "DELETE_WORK_ACTIVITY_ADITIONAL_DATA";

export const work_activity_aditional_data_module = (state = init, action) => {
    switch (action.type) {
        case CREATE_WORK_ACTIVITY_ADITIONAL_DATA:
            return {
                ...state,
                _create_work_activity_aditional_data: action.payload,
            };
        case DELETE_WORK_ACTIVITY_ADITIONAL_DATA:
            return {
                ...state,
                _delete_work_activity_aditional_data: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const createWorkActivityAditionalData = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${WORK_ACTIVITY_ADITIONAL_DATA_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_WORK_ACTIVITY_ADITIONAL_DATA,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_WORK_ACTIVITY_ADITIONAL_DATA,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_WORK_ACTIVITY_ADITIONAL_DATA,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteWorkActivityAditionalData = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(`${URLAPI}${WORK_ACTIVITY_ADITIONAL_DATA_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_WORK_ACTIVITY_ADITIONAL_DATA,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_WORK_ACTIVITY_ADITIONAL_DATA,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_WORK_ACTIVITY_ADITIONAL_DATA,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const clear_work_activity_aditional_data = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
